<template lang="html">
  <div class="main" v-show="show">
    <div class="logo">
      <img v-show="times>18" src="../../assets/images/assist-logo.png" alt="">
      <!-- <i v-show="times>18" class="el-notification__icon el-icon-warning"></i> -->
      <i v-show="times<=18" class="el-notification__icon el-icon-loading"></i>
    </div>
    <span style="margin-left: 4px" v-show="times>18">{{message.Al112}}</span>
    <span v-show="times<=18">{{message.Al113}}</span>
    <a v-if="times>18&&broswer!=='qt'" class="download"  @click="downloadApp"  target="_blank">{{message.Al145}}</a>
    <span v-if="times>18">{{message.Al156}}</span>
    <a  v-if="times>18" class="restart" @click="toStart">{{message.Al115}}</a>
    <div v-if="times>18" class="el-notification__closeBtn el-icon-close" @click="closeWarn"></div>
    <!-- <i v-show="times>18" class="el-notification__icon el-icon-warning"></i>
    <i v-show="times<=18" style="color:#20a0ff" class="el-notification__icon el-icon-loading"></i>
    <div class="el-notification__group is-with-icon">
      <h2 v-show="times>18" class="el-notification__title">{{message.Al112}}</h2>
      <h2 v-show="times<=18" style="padding:12px 0 0 8px" class="el-notification__title">{{message.Al113}}</h2>
      <div v-if="times>18" class="el-notification__content" style="margin-bottom:20px;margin-top:10px">
        {{message.Al114}}<br/>
        <a class="restart" @click="toStart">{{message.Al115}}</a>
        <a class="download" :href="downloadUrl"  target="_blank">{{message.Al116}}</a>
      </div>
      <div v-if="times>18" class="el-notification__closeBtn el-icon-close" @click="closeWarn"></div>
    </div> -->
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      app: 'app',
      notice: 'notice',
      el: 'el'
    }),
    show: function () {
      let value = this.notice.alertWarn && this.broswer !== 'qt'
      return value
    }
  },
  watch: {
    'notice.alertAlive': function (val) {
      if (val && this.broswer !== 'qt') {
        if (!this.app.type) {
          this.times = 30
          this.keepAlive30()
        } else {
          this.$store.dispatch('activeAlive', false)
        }
      }
    },
    'show': function (val) {
      if (val) {
        this.$api.getDownloadUrl(response => {
          if (this._global.config.system === 'mac') {
            this.downloadUrl = response.mac
          } else {
            this.downloadUrl = response.win32
          }
        })
      }
    },
    'el.showDown': function (val) {
      if (val) {
        this.times = 30
        this.$store.dispatch('alertWarn', false)
      }
    }
  },
  data () {
    return {
      message: {
        Al112: this.$lang.ui.app.l112,
        Al113: this.$lang.ui.app.l113,
        Al114: this.$lang.ui.app.l114,
        Al115: this.$lang.ui.app.l115,
        Al145: this.$lang.ui.app.l145,
        Al156: this.$lang.ui.app.l156
      },
      times: 0,
      time: 1000,
      keepFunc: null,
      downloadUrl: '',
      broswer: this._global.config.browser,
    }
  },
  mounted () {
  },
  methods: {
    ping () {
      axios({
        menthod: 'post',
        url: 'https://cydex-local.catontechnology.com:9887/cydex/local/v1/keepalive',
        timeout: 10000
      })
        .then(response => {
          this.$store.dispatch('activeApp', true)
        })
        .catch(error => {
          if (error) {
            if (error.response) {
              if (error.response.status === 404) {
                this.times = 30
                var version = '---'
                this.$api.getAppVersion(response => {
                  if (this._global.config.system === 'mac') {
                    var info = {
                      newVersion: response.mac.version,
                      appVersion: version,
                      downloadUrl: response.mac.downloadUrl
                    }
                  } else {
                    info = {
                      newVersion: response.win32.version,
                      appVersion: version,
                      downloadUrl: response.win32.downloadUrl
                    }
                  }
                  this.$store.dispatch('setInfo', info)
                })
              }
            }
          }
        })
    },
    alive () {
      this.ping()
      if (this.app.type && this.app.login) {
        this.times = 30
      } else if (this.app.type) {
        this.$app.login()
        this.times = 30
      } else {
        if (this.times === 2) {
          this.$app.start()
        }
      }
    },
    keepAlive30 () {
      this.times = 0
      this.$store.dispatch('alertWarn', true)
      // if (this.el.passDown === false) {
      //   this.times = 30
      //   this.$store.dispatch('activeAlive', false)
      //   this.$store.dispatch('alertWarn', false)
      // }
      var keepFunc = setInterval(() => {
        this.times = this.times + 1
        this.alive()
        // if (this.times === 3) {
        //   this.$store.dispatch('passDown', false)
        // }
        if (this.times >= 29) {
          this.$store.dispatch('activeAlive', false)
          clearInterval(keepFunc)
        }
      }, 1000)
    },
    toStart () {
      this.times = 30
      // this.$store.dispatch('passDown', true)
      this.$store.dispatch('alertWarn', true)
      this.$store.dispatch('activeAlive', true)
      this.keepAlive30()
    },
    downloadApp () {
      if (this.downloadUrl) {
        window.open(this.downloadUrl)
      } else {
        this.$store.dispatch('downloadMsg', 'none')
      }
    },
    closeWarn () {
      this.$store.dispatch('alertWarn', false)
    }
  }
}
</script>

<style lang="css" scoped>
.main {
  z-index: 1001;
  position: fixed !important;
  background-color: #007bc5 !important;
  top: 0;
  width: 100%;
  height: 70px !important;
  line-height: 70px;
  color: #fff;
  font-size: 18px;
}
.logo {
  float: left;
  height: 46px;
  width: 46px;
  text-align: center;
  line-height: 60px;
  margin-top: 12px;
  margin-right: 6px;
  margin-left: 56px;
}
.logo img {
  width: 100%;
}
.download {
  cursor: pointer;
  color: #fff;
  height: 45px;
  padding: 6px 15px;
  border-radius: 2px;
  margin: 0 25px 0 10px;
  background-color: #ffa000;
  font-size: 14px;
  height: 22px;
  text-decoration: none;
}
.restart {
  cursor: pointer;
  color: #fff;
  height: 45px;
  padding: 6px 15px;
  border-radius: 2px;
  margin: 0 10px;
  background-color: #ffa000;
  font-size: 14px;
  height: 22px
}
.el-icon-close {
  top: 20px;
  font-size: 26px;
  right: 56px;
  color: #fff;
}
</style>
